import React from 'react';

/**
 * Mission target — stamped tin badge to match the robot pieces.
 * Filled plate + walnut outline + inner ring + glint. No <defs>/gradients:
 * url(#id) fragment refs break under CRA's <base href>.
 */
function StarIcon({ color }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="100%"
      height="100%"
      style={{ display: 'block' }}
    >
      <path
        d="M16 2.6l3.9 9.5 9.5 3.9-9.5 3.9-3.9 9.5-3.9-9.5L2.6 16l9.5-3.9L16 2.6z"
        fill={color}
        stroke="#2a1a0e"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <path
        d="M16 10.6l2 4.9 4.9 2-4.9 2-2 4.9-2-4.9-4.9-2 4.9-2 2-4.9z"
        fill="#fff"
        opacity="0.32"
      />
    </svg>
  );
}

export default StarIcon;
